import type { GeographyMode } from '../../../../shared/user-preferences/types';
import {
  geographyAdministrativeBranchLabels,
  geographyBranchLabels,
} from '../constants/branch-labels';
import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const getGeographyDefinition = (
  geographyMode: GeographyMode = 'msa'
): FilterDefinition<TreeFilter> => {
  const selectionListIds = (
    geographyMode === 'administrative'
      ? ['region', 'country', 'state', 'city']
      : ['region', 'country', 'msa', 'city']
  ) as TreeFilter['selectionListIds'];

  return {
    id: FilterId.GEOGRAPHY,
    name: 'Geography',
    selectionListIds,
    selections: [],
    branches:
      geographyMode === 'administrative'
        ? geographyAdministrativeBranchLabels
        : geographyBranchLabels,
    type: FilterType.TREE,
    isVisible: true,
  };
};

export const geographyDefinition = getGeographyDefinition('msa');

export const geographyHandler: FilterHandler<TreeFilter> = {
  isActive(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length > 0;
  },
  isDefault(currentFilterState: TreeFilter) {
    return currentFilterState.selections.length === 0;
  },
  getEffectiveFilter(currentFilterState: TreeFilter) {
    return { ...currentFilterState };
  },
  getRequiredSelectionListIds(definition: FilterDefinition<TreeFilter>) {
    return definition.selectionListIds;
  },
};
